import { ConfigService } from '../../config/shared/config.service';
import { FeatureService } from '../feature/feature.service';
import { FeatureNameEnum } from '../feature/feature-name.enum';
import { AccessControlEntry } from './access-control-entry';
import { UserService } from 'src/app/users/shared/user.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { LogService } from '../log/log.service';
import { AuthUserInfo } from './auth-user-info.model';
//import { NavigationService } from '../navigation/navigation.service';

@Injectable()
export class AuthGuard implements CanActivate {
  public _authService: AuthService;
  //public _navService: NavigationService;
  public _router: Router;
  public _logService: LogService;

  public constructor(
    authService: AuthService,
    router: Router,
    logService: LogService,
    private _userService: UserService,
    private _featureService: FeatureService,
    private _configService: ConfigService
  ) {
    this._authService = authService;
    this._router = router;
    this._logService = logService;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (this._authService.currentUserIsAuthenticated()) {
      return this._authService.getUserInfo().then((data: AuthUserInfo) => {
        if (data.wli_user_type == 'portal_user') {
          this.handleUnauthenticated();
          return Promise.resolve(false);
        } else {
          return this.checkAuthorization(route);
        }
      });
    } else {
      this.handleUnauthenticated();
      return Promise.resolve(false);
    }
  }

  private checkAuthorization(route: ActivatedRouteSnapshot): Promise<boolean> {
    const accessControlEntries: AccessControlEntry[] = route.data.accessControls ?? [];
    const features: FeatureNameEnum[] = route.data.features ?? [];
    const betaToggles: string[] = route.data.betaToggles ?? [];
    const accessChecks: Promise<boolean>[] = [];
    accessControlEntries.forEach((entry) => {
      accessChecks.push(
        this._userService.getCurrentUserSecurityElementAccessLevel(entry.SecurityElement).then((accessLevel) => {
          return accessLevel >= entry.MinimumAccessLevel;
        })
      );
    });
    features.forEach((feature) => {
      accessChecks.push(
        this._featureService.has(feature).then((hasFeature) => {
          return hasFeature;
        })
      );
    });
    betaToggles.forEach((toggle) => {
      accessChecks.push(
        this._configService.hasBetaFeatureEnabled(toggle).then((hasToggle) => {
          return hasToggle;
        })
      );
    });

    return Promise.all(accessChecks).then((checkResults) => {
      if (checkResults.some((x) => x === false)) {
        this._router.navigate(['access/denied']);
        return false;
      }
      return true;
    });
  }

  private handleUnauthenticated() {
    this._logService.log('Auth Guard', 'AuthGuard returned user is NOT authenticated');
    let url = 'unauthenticated';
    this._router.navigate([url]);
  }
}
